/**
 * Careers JS
 */

// CSS
import '../scss/careers.scss';

// Vendors
import $ from 'jquery';
import datepicker from 'bootstrap-datepicker';

// On mail sent event
document.addEventListener(
  'wpcf7mailsent',
  event => {
    let inputs = event.detail.inputs;
    let firstname = '';
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].name == 'firstname') {
        firstname = inputs[i].value;
      }
    }

    // Send to Thank You Page
    if (firstname.length > 0) {
      window.location.href = '/careers/thank-you/?first_name=' + firstname;
    }
  },
  false
);

// Allow clicking on checkbox/radio labels for better UX
// Disabling because it breaks conditional field functionality
// $('.wpcf7-checkbox .wpcf7-list-item-label').on('click', event => {
//   const input = $(event.currentTarget).prev();
//   input.prop('checked', !input[0].checked);
// });
// $('.wpcf7-radio .wpcf7-list-item-label').on('click', event => {
//   const input = $(event.currentTarget).prev();
//   input.prop('checked', true);
// });

// Add blank option to select
$('.wpcf7-form select option')
  .first()
  .html('');

// Wrap button
$('.wpcf7-form .btn').wrapInner('<span></span>');

// Datepicker
$('#date').datepicker({});

// Handle upload buttons
$('button[data-target]').on('click', event => {
  const targetFileInput = $(event.currentTarget).data('target');
  $(`input[type="file"][name=${targetFileInput}]`).click();

  if (
    !$(event.currentTarget)
      .next()
      .is('.file-input-value-display')
  ) {
    $(event.currentTarget).after(
      '<span class="file-input-value-display"></span>'
    );
    $(event.currentTarget)
      .next()
      .css('margin-left', '15px');
  }

  setInterval(() => {
    let fileName;
    const fileInput = $(`input[type="file"][name=${targetFileInput}]`);

    if (typeof fileInput.val() !== 'undefined') {
      fileName = fileInput
        .val()
        .split('/')
        .pop()
        .split('\\')
        .pop();
      $(event.currentTarget)
        .next()
        .html(fileName);
    }
  }, 1000);
});

// Add website button
$('#add-site').on('click', event => {
  event.preventDefault();

  if ($('.site-hidden-input').length === 1) {
    $(event.currentTarget).hide();
  }

  $('.site-hidden-input')
    .first()
    .removeClass('site-hidden-input');
});

// Show form
setTimeout(() => {
  $('.wpcf7-form').addClass('ready');
}, 200);



// WEBPACK FOOTER //
// ./assets/js/careers.js